module.exports = __webpack_public_path__ + "static/media/tempest.43238d4f.jpg";